module.exports = __webpack_public_path__ + "img/logo.be2e1fdf.png";